export interface ProductPriceListConversion {
  productPriceListConversionId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  conversionUomId: string;
  conversionUomShortDescription: string;
  conversionUomDescription: string;
  conversionQuantity: number;
}
